import { ReactNode } from 'react';

import RoundIconButton from 'approot/shared/round-icon-button/round-icon-button';
import * as Styled from 'approot/shared/styles/actions-menu.style';

type ActionMenuOption = {
  onClick: () => void;
  ariaLabel: string;
  icon: ReactNode;
  disabled?: boolean;
  dataSelector?: string;
};

type Props = {
  options: ActionMenuOption[];
};

const TeachingNotesMenu = ({ options }: Props) => (
  <Styled.ActionsMenuContainer>
    <Styled.ActionsMenu>
      {options.map((option, index) => (
        <RoundIconButton
          key={index}
          onClick={option.onClick}
          icon={option.icon}
          aria-label={option.ariaLabel}
          noBorder
          disabled={option.disabled}
          data-selector={option.dataSelector}
        />
      ))}
    </Styled.ActionsMenu>
  </Styled.ActionsMenuContainer>
);

export default TeachingNotesMenu;
